import { render } from "./awsElasticBlockStore.vue?vue&type=template&id=608952d8"
import script from "./awsElasticBlockStore.vue?vue&type=script&lang=js"
export * from "./awsElasticBlockStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__